import { render } from "./ChecklistDialog.vue?vue&type=template&id=45b71cb9"
import script from "./ChecklistDialog.vue?vue&type=script&lang=js"
export * from "./ChecklistDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__